module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_wayo-8cd805c9f6f8fe3a22c42f266df48cb8.jpg";